import { format } from "date-fns";

const TYPES = [["large", "Large"], ["medium", "Medium"], ["small", "Small"], ["umbrella", "Umbrella"]];
const t = (s) => (s ? (s.split(" ")[1] || "").slice(0, 5) : "");

export const PrintSheet = ({ date, data, noShowFor }) => {
  const allocByLounge = {};
  (data.allocations || []).forEach((a) => { allocByLounge[a.lounge_id] = a; });
  const resByBooking = {};
  (data.reservations || []).forEach((r) => { resByBooking[r.booking_id] = r; });
  const notes = data.notes || {};
  const byType = {};
  (data.lounges || []).forEach((l) => { (byType[l.type] = byType[l.type] || []).push(l); });
  Object.values(byType).forEach((a) => a.sort((x, y) => x.num - y.num));
  const unassigned = (data.reservations || []).filter((r) => !r.assigned_lounge_id);

  return (
    <div id="print-sheet" className="hidden p-2 text-black print:block">
      <div className="mb-3 flex items-baseline justify-between border-b-2 border-black pb-2">
        <h1 className="text-xl font-bold">TRIBE Beach Lounge — Allocation Sheet</h1>
        <span className="text-sm">{format(date, "EEEE, dd MMM yyyy")}</span>
      </div>
      {TYPES.map(([type, label]) => {
        const lounges = byType[type] || [];
        if (!lounges.length) return null;
        return (
          <div key={type} className="mb-3">
            <h2 className="mb-1 text-sm font-bold uppercase">{label}</h2>
            <table className="w-full border-collapse text-[11px]">
              <thead>
                <tr className="border-b border-black text-left">
                  <th className="w-24 py-0.5 pr-2">Lounge</th>
                  <th className="pr-2">Guest</th>
                  <th className="w-24 pr-2">Time</th>
                  <th className="w-12 pr-2">Pax</th>
                  <th className="w-20 pr-2">Status</th>
                  <th>Tags / Note</th>
                </tr>
              </thead>
              <tbody>
                {lounges.map((l) => {
                  const a = allocByLounge[l.id];
                  const r = a ? resByBooking[a.booking_id] : null;
                  const ns = a && noShowFor(a);
                  return (
                    <tr key={l.id} className="border-b border-gray-300 align-top">
                      <td className="py-0.5 pr-2 font-semibold">{l.label}</td>
                      <td className="pr-2">{a ? a.guest_name : "—"}</td>
                      <td className="pr-2">{a ? `${t(a.start_date)}–${t(a.end_date)}` : ""}</td>
                      <td className="pr-2">{r && r.party_size ? r.party_size : ""}</td>
                      <td className={`pr-2 ${ns ? "font-bold" : ""}`}>
                        {a ? (a.status === "arrived" ? "Arrived" : (ns ? "NO-SHOW" : "Waiting")) : "Free"}
                      </td>
                      <td>
                        {r && r.tags && r.tags.length ? r.tags.join(", ") : ""}
                        {notes[l.id] ? `  ✎ ${notes[l.id]}` : ""}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        );
      })}
      {unassigned.length > 0 && (
        <div className="mt-3">
          <h2 className="mb-1 text-sm font-bold uppercase">Not yet seated ({unassigned.length})</h2>
          <table className="w-full border-collapse text-[11px]">
            <tbody>
              {unassigned.map((r) => (
                <tr key={r.booking_id} className="border-b border-gray-300">
                  <td className="py-0.5 pr-2 font-semibold">{r.guest_name}</td>
                  <td className="pr-2">{TYPES.find((x) => x[0] === r.lounge_type)?.[1]}</td>
                  <td className="pr-2">{t(r.start_date)}–{t(r.end_date)}</td>
                  <td className="pr-2">{r.party_size ? `${r.party_size} pax` : ""}</td>
                  <td>{r.tags?.join(", ")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
